import * as React from 'react';

export const PinCodeAuthentication: React.FC = () => null;
